let config = [
  {
    name: '品牌日 一',
    type: "module-name"
  },
  {
    key: "property_data",
    name: "属性",
    type: "custom",
    content: [
      {
        key: "type",
        name: "样式",
        type: "radio-box-img",
        width: 84,
        "radio-list": [
          {
            url:
              "https://img.mockuai.com/tms/2018/1/10/upload_c9b8a668b7812c4277a638986eab1e93.png",
            value: 1,
            text: "单列"
          },
          {
            url:
              "https://img.mockuai.com/tms/2018/1/10/upload_45d9acc229960a30ca9b14ab951d0986.png",
            value: 2,
            text: "双列"
          }
        ]
      },
      {
        key: 'list',
        name: '数据',
        type: 'upload-data',
        link_down: 'https://cdn.mockuai.com/tms/template-normal-01.xlsx',
        format: (list)=>{
          const map = {
            '佣金': 'commission',
            '到手价': 'price',
            '副标题': 'subtitle',
            '商品标题': 'title',
            '销售列表': 'sales',
            '销量描述': 'sale_desc',
            '图片': 'img_url',
            '商品ID': 'id'
          }
          const data = list.map(item=>{
            const obj = {}
            Object.keys(item).forEach(key=>{
              const _key = /销售列表/.test(key) ? '销售列表' : key
              const mapKey = map[_key]
              if(mapKey === 'sales'){
                if(!obj[mapKey]) obj[mapKey] = [];
                obj[mapKey].push(item[key])
              } else {
                obj[mapKey] = item[key]
              }
            })
            return obj
          })
          return data
        }
      },
      {
        key: "background_color",
        name: "背景颜色",
        type: "color"
      },
      {
        key: "title_color",
        name: "标题色",
        type: "color"
      },
      {
        key: "subtitle_bg_color",
        name: "副标题背景色",
        type: "color"
      },
      {
        key: "btn_lf_text_color",
        name: "按钮左文案",
        type: "color"
      },
      {
        key: "btn_rt_text_color",
        name: "按钮右文案",
        type: "color"
      },
      {
        key: "btn_lf_bg",
        name: "按钮左背景色",
        type: "gradient-color"
      },
      {
        key: "btn_rt_bg",
        name: "按钮右背景色",
        type: "gradient-color"
      },
      {
        "key": "tips",
        "value": "样式一专属",
        "type": "tips"
      },
      {
        key: "sale_color",
        name: "销售列表高亮",
        type: "color"
      },
      {
        key: "desc_color",
        name: "说明文案颜色",
        type: "color"
      },
    ]
  }
];
export default config;
